import { createRouter, createWebHashHistory } from 'vue-router';
import homePage_pc from '@/components/web/newHomePage.vue';
import landingPage from '@/components/mobile/landingPage.vue';
import zhaopin from '@/components/web/zhaopin.vue';
import platform from '@/components/mobile/platform.vue';
import customer from '@/components/mobile/customer.vue';

const routes = [
  {
    path: '/landing',
    name: 'landingPage',
    meta: {
      title: '真保数科平台',
      data: {
        name: 'viewport',
        content: 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0'
      }
    },
    component: landingPage,
  },
  {
    path: '/landing/platform',
    name: 'platform',
    meta: {
      title: '保理人端账号绑定',
      data: {
        name: 'viewport',
        content: 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0'
      }
    },
    component: platform,
  },
  {
    path: '/landing/customer',
    name: 'customer',
    meta: {
      title: '供应商端账号绑定',
      data: {
        name: 'viewport',
        content: 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0'
      }
    },
    component: customer,
  },
  {
    path: '/',
    name: 'homePage_pc',
    meta: {
      title: '真保数科平台',
    },
    component: homePage_pc
  },
  {
    path: '/offer',
    name: 'offer',
    meta: {
      title: '招聘信息',
    },
    component: zhaopin
  }
]
const routerConfig = createRouter({history: createWebHashHistory(), routes})

const writer = (to) => {
  console.log(to)
  document.title = to.meta.title || to.name;
  if(to.meta.data) {
    const meta = document.createElement('meta');
    meta.content = to.meta.data.content;
    meta.name = to.meta.data.name;
    document.getElementsByTagName('head')[0].appendChild(meta);
  }
}


export function createGuard(router) {
  router.beforeEach((to, from, next) => {
    writer(to);   //调用自动添加meta
    next();
  })
}


export default routerConfig